/**
 * Copyright (c) 2022 Strategio Digital s.r.o.
 * @author Jiří Zapletal (https://strategio.digital, jz@strategio.digital)
 */

const makePrettyNumber = (invoiceNumber: number): string => {
    const numString = invoiceNumber.toString()
    const prefix = numString.slice(0, 4)
    const suffix = numString.slice(4, numString.length)

    return `${prefix}-${suffix}`
}

const makeFirstInvoiceNumberInYear = () => {
    return parseInt(`${new Date().getFullYear()}000001`)
}

const makeSuggestedInvoiceNumber = (nextInvoiceNum: number, potentialInvoiceNum: number): number => {
    const currentYear = new Date().getFullYear()
    const suffix = nextInvoiceNum.toString().slice(0, 4)
    const nextYear = suffix ? parseInt(suffix) : null

    if (nextYear && nextYear < currentYear) {
        const firstInvoiceNumber = makeFirstInvoiceNumberInYear()
        if (potentialInvoiceNum && firstInvoiceNumber > potentialInvoiceNum) {
            return firstInvoiceNumber
        }

        return potentialInvoiceNum
    }

    return 0
}

export const invoiceHelper = () => {
    return {
        makePrettyNumber,
        makeSuggestedInvoiceNumber,
        makeFirstInvoiceNumberInYear
    }
}